/* Spinny's weather + morning looks (v11): the drawings, and which weather gets which look.
   Loaded just before a1-chatbot.js, which uses window.A1ChatLooks. If this file is missing, Spinny simply
   skips the weather and coffee. Drawings are in each pose's image pixels (idle 132, point 151, scurry 197
   wide, all 264 tall), like the holiday hats: the umbrella sits BEHIND him (his glove covers the handle,
   his head hides the shaft), so it looks held; it moves, bobs and mirrors with him. The puddle, cloud,
   rain and snow stay at his parked spot when he walks off to point. Colours read on dark and light pages. */
(function () {
  'use strict';
  // He only ever holds things in a closed fist. When he has the coffee and/or the umbrella, his standing and
  // pointing poses switch to versions with the arm(s) raised and fist(s) closed:
  //   idleCup  his right arm (page side) raised: holds the coffee, or the umbrella if that's all he has
  //   idleBoth both arms raised: coffee in the right fist (page side), umbrella in the left
  //   pointUp  pointing, free arm raised: holds the umbrella, else the coffee (one item while pointing)
  // a1-chatbot.js reads its pose images from window.A1_CHAT_POSES; this file runs first, shares that object
  // and updates it whenever what he's holding changes (a1-chatbot.js then re-sets his pose).
  var P = (function () {
    try {
      var p = window.A1_CHAT_POSES || JSON.parse(document.getElementById('a1ChatPoses').textContent);
      window.A1_CHAT_POSES = p;
      return p;
    } catch (e) { return null; }
  })();
  var BASE = P ? { idle: P.idle, point: P.point } : {};
  var held = { cup: false, um: false };
  var MORNING = (function () { // same 5:00-9:29am window and theme switch a1-chatbot.js uses for the coffee
    try {
      var root = document.getElementById('a1Chat');
      if (!root || root.getAttribute('data-weather') === 'off') return false;
      var m = /[?&]a1chat_morning=([01])/.exec(location.search);
      var d = window.A1_CHAT_NOW ? new Date(window.A1_CHAT_NOW) : new Date(), mins = d.getHours() * 60 + d.getMinutes();
      return m ? m[1] === '1' : mins >= 300 && mins < 570;
    } catch (e) { return false; }
  })();
  function setHeld(cup, um) {
    held.cup = held.cup || cup; held.um = held.um || um;
    if (!P) return;
    var c = held.cup, u = held.um;
    P.idle = c && u && P.idleBoth ? P.idleBoth : (c || u) && P.idleCup ? P.idleCup : BASE.idle;
    P.point = (c || u) && P.pointUp ? P.pointUp : BASE.point;
  }
  setHeld(MORNING, false);
  if (P) ['idleCup', 'idleBoth', 'pointUp'].forEach(function (k) { if (P[k]) { var i = new Image(); i.src = P[k]; } });
  function mode(pose) { // which image is showing for this pose
    if (!P) return 'plain';
    if (pose === 'idle') return P.idleBoth && P.idle === P.idleBoth ? 'both' : P.idleCup && P.idle === P.idleCup ? 'one' : 'plain';
    if (pose === 'point') return P.pointUp && P.point === P.pointUp ? 'one' : 'plain';
    return 'fists'; // walking: both hands are already fists
  }
  // Fist centres (x, y) in each pose image, from the image builder (hold_poses.py).
  var FIST = { idleL: [14, 97], idleR: [116, 98], pointL: [16, 97], scurryBack: [52, 145], scurryFront: [166, 112] };
  function umbrellaGrip(pose) {
    var m = mode(pose);
    if (pose === 'scurry') return FIST.scurryBack;
    if (pose === 'idle') return m === 'both' ? FIST.idleR : m === 'one' ? FIST.idleL : [27, 166];
    return m === 'one' ? FIST.pointL : [20, 159];
  }
  var TOP = { idle: [60, -16], point: [70, -16], scurry: [116, -18] }; // where the umbrella tip goes: over his head
  var FACE = { // eyes (sunglasses) and neck (scarf): x, y, lean
    idle: { eyes: [63, 56, 0], neck: [66, 100, 0, 52] },
    point: { eyes: [72, 56, 0], neck: [72, 100, 1, 50] },
    scurry: { eyes: [120, 52, 9], neck: [111, 99, 13, 50] }
  };
  function umbrella(pose, lift) {
    setHeld(false, true);
    var g = umbrellaGrip(pose), gx = g[0], gy = g[1], tx = TOP[pose][0], ty = TOP[pose][1] - (lift || 0);
    var dx = tx - gx, dy = ty - gy, L = Math.sqrt(dx * dx + dy * dy), ang = Math.atan2(dx, -dy) * 180 / Math.PI;
    var R = 60, cy = -L, k = 1.2; // canopy rim centre, in the umbrella's own frame (shaft runs up the -y axis)
    var top = cy - 47 * k, sc = cy - 8; // dome top; scallop dip
    var dome = 'M' + (-R) + ',' + cy + ' C' + (-R) + ',' + (cy - 30 * k) + ' ' + (-R * 0.55) + ',' + (cy - 46 * k) + ' 0,' + top +
      ' C' + (R * 0.55) + ',' + (cy - 46 * k) + ' ' + R + ',' + (cy - 30 * k) + ' ' + R + ',' + cy +
      ' Q' + (R * 0.75) + ',' + sc + ' ' + (R / 2) + ',' + cy + ' Q' + (R / 4) + ',' + sc + ' 0,' + cy +
      ' Q' + (-R / 4) + ',' + sc + ' ' + (-R / 2) + ',' + cy + ' Q' + (-R * 0.75) + ',' + sc + ' ' + (-R) + ',' + cy + ' Z';
    var mid = 'M0,' + top + ' C' + (-R * 0.22) + ',' + (cy - 40 * k) + ' ' + (-R * 0.34) + ',' + (cy - 20 * k) + ' ' + (-R / 4) + ',' + sc +
      ' Q0,' + (cy + 1) + ' ' + (R / 4) + ',' + sc + ' C' + (R * 0.34) + ',' + (cy - 20 * k) + ' ' + (R * 0.22) + ',' + (cy - 40 * k) + ' 0,' + top + ' Z';
    return '<g transform="translate(' + gx + ',' + gy + ') rotate(' + ang.toFixed(1) + ')"><g class="a1u-sway">' +
      '<path d="M0,-4 L0,' + (cy + 2) + '" stroke="#2b3540" stroke-width="3.4" stroke-linecap="round"/>' +
      '<path d="M0,8 L0,18 Q0,27 -8,27 Q-15,27 -15,19" stroke="#7a4520" stroke-width="5" fill="none" stroke-linecap="round"/>' +
      '<path d="' + dome + '" fill="#2f80d8" stroke="#0f2a4a" stroke-width="2.6" stroke-linejoin="round"/>' +
      '<path d="' + mid + '" fill="#f4f8fd" stroke="#0f2a4a" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M' + (-R * 0.84) + ',' + (cy - 20 * k) + ' C' + (-R * 0.7) + ',' + (cy - 36 * k) + ' ' + (-R * 0.45) + ',' + (cy - 43 * k) + ' ' + (-R * 0.26) + ',' + (cy - 45 * k) + '" stroke="#8cc0f2" stroke-width="3" fill="none" stroke-linecap="round"/>' +
      '<path d="M0,' + top + ' L0,' + (top - 10) + '" stroke="#2b3540" stroke-width="3.4" stroke-linecap="round"/>' +
      '</g></g>';
  }
  // A proper diner mug held in his fist: white, navy A1 band, coffee inside, steam. (x, y) = centre of the mug;
  // flip puts the handle on the right (for a fist to the right of the mug).
  function mugSvg(x, y, flip) {
    var handle = flip ? 'M14,-8 q6,0 7,5 M14,8 q6,0 7,-5' : 'M-14,-8 q-6,0 -7,5 M-14,8 q-6,0 -7,-5';
    return '<g transform="translate(' + x + ',' + y + ') scale(1.2)">' +
      '<g class="a1-steam" fill="none" stroke="#aebfd1" stroke-width="2.4" stroke-linecap="round">' +
      '<path d="M-6,-19 q-3,-5 0,-9 q3,-4 0,-9"/><path d="M1,-20 q-3,-5 0,-9 q3,-4 0,-9"/><path d="M8,-19 q-3,-5 0,-9 q3,-4 0,-8"/></g>' +
      '<path d="' + handle + '" stroke="#7f94aa" stroke-width="4.6" fill="none" stroke-linecap="round"/>' +
      '<path d="' + handle + '" stroke="#fbfcfe" stroke-width="2.6" fill="none" stroke-linecap="round"/>' +
      '<path d="M-14,-13 L14,-13 L12.5,12 Q12,15 9,15 L-9,15 Q-12,15 -12.5,12 Z" fill="#fbfcfe" stroke="#7f94aa" stroke-width="1.4" stroke-linejoin="round"/>' +
      '<path d="M6,-12.4 L13.3,-12.4 L11.9,11.8 Q11.5,14.2 9,14.2 L5,14.2 Z" fill="#dfe6ee"/>' +
      '<path d="M-9.6,-8 L-9,9" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/>' +
      '<path d="M-13.65,-2.5 L13.65,-2.5 L13.2,5 L-13.2,5 Z" fill="#0f2a4a"/>' +
      '<text x="0" y="3.6" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="6.6" font-weight="700" fill="#fff">A1</text>' +
      '<ellipse cx="0" cy="-13" rx="14" ry="3.6" fill="#fbfcfe" stroke="#7f94aa" stroke-width="1.4"/>' +
      '<ellipse cx="0" cy="-12.7" rx="11.6" ry="2.5" fill="#4a2a12"/>' +
      '<ellipse cx="-2" cy="-13.2" rx="5.5" ry="1" fill="#8a5a2c" opacity=".85"/></g>';
  }
  function shades(pose) {
    var e = FACE[pose].eyes;
    return '<g transform="translate(' + e[0] + ',' + e[1] + ') rotate(' + e[2] + ') scale(1.3)">' +
      '<path d="M-22,-3 L22,-3" stroke="#1b1b1b" stroke-width="2.4"/>' +
      '<path d="M-21,-4 L-3,-4 Q-2,6 -11,7 Q-20,7 -21,-4 Z" fill="#1b1b1b"/>' +
      '<path d="M3,-4 L21,-4 Q20,7 11,7 Q2,6 3,-4 Z" fill="#1b1b1b"/>' +
      '<path d="M-17,-1 L-12,-1" stroke="#7d8a97" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M7,-1 L12,-1" stroke="#7d8a97" stroke-width="1.6" stroke-linecap="round"/></g>';
  }
  function scarf(pose) {
    var n = FACE[pose].neck, w = n[3] / 2;
    return '<g transform="translate(' + n[0] + ',' + n[1] + ') rotate(' + n[2] + ')">' +
      '<path d="M' + (w * 0.35) + ',4 L' + (w * 0.55) + ',40 L' + (w * 0.95) + ',38 L' + (w * 0.8) + ',3 Z" fill="#b02a40"/>' +
      '<path d="M' + (w * 0.48) + ',22 L' + (w * 0.87) + ',21 M' + (w * 0.52) + ',30 L' + (w * 0.91) + ',29" stroke="#fff" stroke-width="2.6"/>' +
      '<path d="M' + (w * 0.55) + ',40 l-1,4 M' + (w * 0.68) + ',40 l0,4 M' + (w * 0.82) + ',39 l1,4" stroke="#b02a40" stroke-width="1.6"/>' +
      '<path d="M' + (-w - 2) + ',-5 Q0,4 ' + (w + 2) + ',-5 L' + (w + 1) + ',7 Q0,16 ' + (-w - 1) + ',7 Z" fill="#c8314a"/>' +
      '<path d="M' + (-w * 0.45) + ',0 L' + (-w * 0.45) + ',11 M' + (w * 0.15) + ',2 L' + (w * 0.15) + ',13" stroke="#fff" stroke-width="3"/>' +
      '</g>';
  }
  var WX_HOME = {
    puddle: '<svg class="a1h-item a1h-puddle" viewBox="0 0 140 26">' +
      '<ellipse cx="70" cy="15" rx="69" ry="10" fill="#2f73b8" opacity=".55"/>' +
      '<ellipse cx="70" cy="15" rx="66" ry="8.6" fill="#5aa2e6" opacity=".85"/>' +
      '<ellipse cx="70" cy="14" rx="52" ry="5.6" fill="#9dd0fb" opacity=".85"/>' +
      '<path d="M30,11 Q44,8 58,10" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round" opacity=".9"/>' +
      '<g fill="none" stroke="#fff" stroke-width="2">' +
      '<ellipse class="a1-ripple" cx="20" cy="15" rx="10" ry="3"/><ellipse class="a1-ripple a1-r2" cx="120" cy="16" rx="10" ry="3"/>' +
      '<ellipse class="a1-ripple a1-r3" cx="40" cy="19" rx="9" ry="2.6"/><ellipse class="a1-ripple a1-r4" cx="100" cy="11" rx="8" ry="2.4"/></g></svg>',
    snow: '<svg class="a1h-item a1h-snowpile" viewBox="0 0 140 34">' +
      '<path d="M1,34 C2,22 12,17 24,18 C30,8 46,5 56,12 C64,2 84,1 92,11 C102,6 118,9 122,19 C132,18 140,25 139,34 Z" fill="#fff" stroke="#9fb6cf" stroke-width="1.6"/>' +
      '<path d="M8,34 C20,27 44,25 70,28 C96,25 120,27 132,34 Z" fill="#d5e4f3"/>' +
      '<path d="M30,16 Q38,11 46,12 M70,8 Q78,5 86,8" stroke="#eef5fc" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
      '<circle cx="50" cy="20" r="1.6" fill="#b9d3ee"/><circle cx="96" cy="17" r="1.6" fill="#b9d3ee"/><circle cx="72" cy="22" r="1.3" fill="#b9d3ee"/></svg>'
  };
  // a cloud over his corner, so rain and snow read at a glance; it stays put when he walks off
  var CLOUD = { rain: ['#8696aa', '#3f5068', '#c3cfdc'], storm: ['#5c6a80', '#273244', '#8d9bb0'], snow: ['#e3e9f0', '#8a9bb0', '#ffffff'] };
  function cloudSvg(kind) {
    var col = CLOUD[kind] || CLOUD.rain;
    return '<svg class="a1fx-cloud" viewBox="0 0 170 64" aria-hidden="true">' +
      '<path d="M24,58 C6,58 2,40 15,33 C11,17 31,8 44,17 C50,4 73,0 85,13 C95,2 120,4 124,21 C140,14 160,25 153,40 C167,44 165,59 149,59 Z" fill="' + col[0] + '" stroke="' + col[1] + '" stroke-width="2.4" stroke-linejoin="round"/>' +
      '<path d="M30,27 C36,18 49,17 56,25 M92,17 C100,10 112,12 116,20" stroke="' + col[2] + '" stroke-width="3.4" fill="none" stroke-linecap="round" opacity=".9"/>' +
      '<path d="M20,52 C60,57 110,57 150,52" stroke="' + col[1] + '" stroke-width="1.6" fill="none" opacity=".35"/></svg>';
  }
  // Turns a weather report into what he wears. A normal day gives an empty look: plain Spinny.
  function lookFor(wx, hour) {
    var L = {};
    if (!wx) return L;
    var c = wx.cond, t = wx.tempF, w = wx.windMph;
    if (c === 'rain' || c === 'storm') { L.umbrella = 1; L.puddle = 1; L.fx = c === 'storm' ? ['rain', 40] : ['rain', 28]; L.cloud = c; }
    if (c === 'snow') { L.snow = 1; L.scarf = 1; L.fx = ['snow', 26]; L.cloud = 'snow'; }
    if (t != null && t <= 32) L.scarf = 1;
    if (c === 'clear' && t != null && t >= 88 && hour >= 9 && hour < 19) L.shades = 1;
    if (L.umbrella && w != null && w >= 20) L.windy = 1;
    return L;
  }
  var WX_PREVIEW = {
    rain: { cond: 'rain' }, storm: { cond: 'storm', windMph: 25 }, snow: { cond: 'snow', tempF: 28 },
    hot: { cond: 'clear', tempF: 95 }, cold: { cond: 'cloudy', tempF: 20 }, wind: { windMph: 30 }, clear: { cond: 'clear', tempF: 70 }
  };
  function particles(type, n) {
    var h = '';
    for (var i = 0; i < n; i++) {
      var x = Math.round(4 + (i + Math.random() * 0.8) * (92 / n));
      // they start mid-fall (negative delay), so the sky is full the moment the page shows
      var lead = type === 'rain' ? -Math.random() * 1.1 : -Math.random() * 7;
      var style = '--x:' + x + '%;--d:' + lead.toFixed(2) + 's;--t:' + (4 + Math.random() * 3).toFixed(2) + 's;' +
        '--s:' + (0.7 + Math.random() * 0.6).toFixed(2) + ';--sy:' + Math.round(60 + Math.random() * 200) + 'px;';
      h += '<span class="a1fx a1fx-' + type + (x > 50 ? ' a1fx-near' : '') + '" style="' + style + '"></span>';
    }
    return h;
  }
  var WX_TEXT = { rain: 'Rainy out there! Questions? Ask me!', snow: 'Snow day! Questions? Ask me!',
    shades: 'Stay cool! Questions? Ask me!', scarf: 'Brr! Questions? Ask me!' };


  function cupAt(pose, hasUmbrella) { // the mug, gripped in a fist (never just floating)
    setHeld(true, !!hasUmbrella);
    var m = mode(pose);
    if (pose === 'scurry') return mugSvg(FIST.scurryFront[0] + 14, FIST.scurryFront[1] + 2);
    if (pose === 'idle' && m !== 'plain') return mugSvg(FIST.idleL[0] - 16, FIST.idleL[1] + 1, true);
    if (pose === 'point' && m === 'one' && !hasUmbrella) return mugSvg(FIST.pointL[0] - 16, FIST.pointL[1] + 1, true);
    return ''; // no free fist (or the pose images are missing): he doesn't hold it
  }
  function sky(L) {
    return '<div class="a1-chat-fx a1fx-wx a1fx-wx-' + L.cloud + '" aria-hidden="true">' + cloudSvg(L.cloud) + particles(L.fx[0], L.fx[1]) + '</div>';
  }

  window.A1ChatLooks = {
    umbrella: umbrella, scarf: scarf, shades: shades, cupAt: cupAt,
    puddle: WX_HOME.puddle, snowPile: WX_HOME.snow, sky: sky,
    lookFor: lookFor, preview: WX_PREVIEW, text: WX_TEXT
  };
})();
